export default __webpack_public_path__ + "static/media/background_shape_1.f865d46d.svg";